export default "__VITE_ASSET__14ac3cec__"